import React from 'react';
import { Dropdown, Menu } from 'antd';
import { Member } from '../types';
import MemberAvatar from '../MemberAvatar/MemberAvatar.tsx';
import MemberPreviewTooltip from '../MemberPreviewTooltip/MemberPreviewTooltip.tsx';
import TooltipSystemV2 from '../../DesignSystem/TooltipSystemV2/TooltipSystemV2';
import './MoreMembersDropdown.scss';

interface MoreMembersDropdownProps {
  members: Member[];
}

const MoreMembersDropdown = ({ members }: MoreMembersDropdownProps) => {
  const menu = (
    <Menu>
      {members.map((member) => (
        <Menu.Item key={member.connectionId}>
          <TooltipSystemV2
            title={<MemberPreviewTooltip member={member} />}
            placement="left">
            <div className="more-members-dropdown__item">
              <MemberAvatar member={member} />
              <div className="more-members-dropdown__item-name">
                {member.profileData.fullName}
              </div>
            </div>
          </TooltipSystemV2>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="more-members-dropdown">
      <Dropdown overlay={menu}>
        <div className="more-members-dropdown__button">
          <span>+{members.length}</span>
        </div>
      </Dropdown>
    </div>
  );
};

export default MoreMembersDropdown;
